export const GUIDE_AUTOCOMPLETE_LIST_HEADER_LABEL =
  'Liste de guides disponibles';
export const ARTICLE_ENHANCEMENT_GUIDES_TITLE = 'Guides';
export const NO_ARTICLE_GUIDE_SELECTED_TITLE = 'Aucun guide de selectionné';
export const GUIDE_SEARCH_BAR_PLACEHOLDER = 'Rechercher un guide';
